import CustomDrawer from "@/components/drawer";
import useIsSmall from "@/hooks/useIsSmall";
import SelectDate from "@/modules/team/addShift/SelectDate";

import { Button, Container, Group, Modal, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconArrowRight, IconChevronDown } from "@tabler/icons-react";
import moment from "moment-jalaali";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  title: string;
  customComponent?: React.ReactNode;
  route?: string;
  showHome?: boolean;
  bg?: string;
  selectedDate: Date[];
  setSelectedDate: (date: Date[]) => void;
};

function ShiftsScheduleHeader({
  customComponent,
  route,
  bg,
  title,
  selectedDate,
  setSelectedDate,
}: Props) {
  const [opened, { open, close }] = useDisclosure(false);

  const [showDate, setShowDate] = useState<Date[]>();
  const isSmall = useIsSmall();
  const navigate = useNavigate();

  const formatDateRange = (dates: Date[]) => {
    if (!dates || dates.length < 2) return "";

    const start = moment(dates[0]);
    const end = moment(dates[1]);

    const startDay = start.format("jD");
    const startMonth = start.format("jMMMM");
    const startYear = start.format("jYYYY");

    const endDay = end.format("jD");
    const endMonth = end.format("jMMMM");
    const endYear = end.format("jYYYY");

    // Same year and month
    if (startYear === endYear && startMonth === endMonth) {
      return `${startDay} - ${endDay} ${startMonth} ${startYear}`;
    }
    // Same year, different months
    else if (startYear === endYear) {
      return `${startDay} ${startMonth} - ${endDay} ${endMonth} ${startYear}`;
    }
    // Different years
    else {
      return `${startDay} ${startMonth} ${startYear} - ${endDay} ${endMonth} ${endYear}`;
    }
  };

  return (
    <>
      <Container
        w="100%"
        size="full"
        bg={bg || "white"}
        styles={{
          root: {
            position: "sticky",
            top: 0,
            zIndex: 20,
            borderBottom: "1px solid var(--mantine-color-gray-2)",
          },
        }}
      >
        <Stack w="100%" h={56} justify="center">
          <Group justify="space-between">
            <Group flex={1}>
              <IconArrowRight
                strokeWidth={1}
                onClick={() => (route ? navigate(route) : navigate(-1))}
              />
            </Group>
            <Stack gap="0" justify="center" align="center" flex={1}>
              <Text fw="500">{title}</Text>
              <Group
                gap="5"
                onClick={open}
                wrap="nowrap"
                styles={{
                  root: {
                    cursor: "pointer",
                  },
                }}
              >
                <IconChevronDown size={15} stroke={1.5} />
                <Text
                  size="xs"
                  styles={{
                    root: {
                      textWrap: "nowrap",
                    },
                  }}
                >
                  {selectedDate
                    ? formatDateRange(selectedDate)
                    : "انتخاب تاریخ"}
                </Text>
              </Group>
            </Stack>

            <Group flex={1}>{customComponent}</Group>
          </Group>
        </Stack>
      </Container>

      <Modal title="انتخاب تاریخ" opened={opened && !isSmall} onClose={close}>
        <Stack flex={1}>
          <Stack flex={1}>
            <SelectDate minDate={false} setDate={(e) => setShowDate(e)} />
          </Stack>
          <Button
            fullWidth
            pos="sticky"
            bottom={0}

            onClick={() => {
              setSelectedDate(showDate || []);
              close();
            }}
          >
            اعمال
          </Button>
        </Stack>
      </Modal>

      <CustomDrawer
        opened={opened && isSmall}
        close={close}
        onClose={close}
        position="bottom"
        custom="select-date"
        title="انتخاب تاریخ"
      >
        <Stack h="54svh" flex={1}>
          <Stack flex={1}>
            <SelectDate minDate={false} setDate={(e) => setShowDate(e)} />
          </Stack>
          <Button
            fullWidth
            pos="sticky"
            bottom={0}

            onClick={() => {
              setSelectedDate(showDate || []);
              close();
            }}
          >
            اعمال
          </Button>
        </Stack>
      </CustomDrawer>
    </>
  );
}

export default ShiftsScheduleHeader;
